import { useAccountCompanyId } from 'application/hooks';
import { ModalTypes } from 'application/providers/ModalProvider';
import { selectIsAcceptanceAdvancedSigningLoading, startAcceptanceAdvancedSigning } from 'application/store';
import { INTEGRATION_PAGE_PATH } from 'application/consts';
import { RouterUtils } from 'application/providers/RouterProvider';
import { useAppDispatch, useAppSelector } from 'application/providers/StoreProvider';

interface AcceptanceAdvancedModalViewModel {
  startSigningAcceptanceAdvancedLoading: boolean;
  handleRedirectToAcceptanceAdvanced: () => Promise<void>;
}

interface Props {
  showStartSigningErrorNotification: () => void;
  openModal: (type: ModalTypes, props: {}) => void;
  close: (count?: number) => void;
  afterClose?: () => void;
}

const URI_FOR_RETURN = `${window.location.origin}/${RouterUtils.generatePath(INTEGRATION_PAGE_PATH, { type: 'sbbol' })}`;

const useAcceptanceAdvancedModalViewModel = ({
  openModal,
  close,
  afterClose,
}: Props): AcceptanceAdvancedModalViewModel => {
  const dispatch = useAppDispatch();
  const startSigningAcceptanceAdvancedLoading = useAppSelector(selectIsAcceptanceAdvancedSigningLoading());

  const companyId = useAccountCompanyId();

  const handleRedirectToAcceptanceAdvanced = async () => {
    dispatch(
      startAcceptanceAdvancedSigning({
        companyId,
        uriForReturn: URI_FOR_RETURN,
        fallbackFn: () => {
          openModal(ModalTypes.SBERBUSSINESS_OPEN, {});
        },
      })
    );

    close();
    afterClose?.();
  };

  return {
    handleRedirectToAcceptanceAdvanced,
    startSigningAcceptanceAdvancedLoading,
  };
};

export default useAcceptanceAdvancedModalViewModel;
